import React from "react";
import "../../styles/team.css";

import hamza from '../../images/hamza.jpg';
import alex from '../../images/alex.jpg';
import david from '../../images/david.png';
import getty from '../../images/getty.jpg';

const teamMembers = [
    {
        imgurl: hamza,
        name: 'Hamza Iddrisu',
        position: 'Consultant and Project Manager, Video Editor',
        social: <a href='https://instagram.com/hamza_xid?gshid=YmMTA2M2Y='><span><i class="ri-instagram-line"></i></span> hamza_xid</a>,
    },
    {
        imgurl: alex,
        name: 'Alexander Abeiku Abakah',
        position: 'Web Developer',
        social: <a href='//www.linkedin.com/in/alexander-abeiku-abakah-519445204?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B349KmhHcQ8GE0Pyd4GZt0g%3D%3D'><span><i class="ri-linkedin-box-fill"></i></span>Alexander</a>,
        
    },
    {
        imgurl: david,
        name: 'David Dankwa Agyei',
        position: 'Graphic Designer',
        social: <a href='https://instagram.com/iamdankwa?igshid=YmMTA2M2Y='><span><i class="ri-instagram-line"></i></span> iamdankwa</a>,
    },
    {
        imgurl: getty,
        name: 'Gertrude Buah',
        position: 'Content Developer, Human Resource Personnel',
        social: <a href='https://instagram.com/nadjiewrites?igshid=YmMyTA2M2Y='><span><i class="ri-instagram-line"></i></span> nadjiewrites</a>,
    },
]

const Team = () => {
    return (
    <section className="our_team">
   <div className="container">
    <div className="team_content">
        <h2>Meet <span className="highlight">our team</span></h2>
        <p className="mtt"><i>For any advertisement journey you seek to embark on, our <span className="highlight" >talented team</span> is more than ready to execute their indisputable prowess at aiding you chalk successes as you achieve your business goals</i></p>
    </div>

    <div className="team_wrapper">
        {teamMembers.map((item, index) => (
            <div className="team_item" key={index}>
            <div className="team_img">
              <img src={item.imgurl} alt="" />  
            </div>
            <div className="team_details">
                <h4>{item.name}</h4>
                <p className="description">{item.position}</p>

                <div className="team_member-social">
                
                <h4>{item.social}</h4>
                </div>
            </div>
        </div>
        )
        
        ) 
        
        }
    </div>
   </div>
    </section>
    );
};

export default Team;